module.exports = __webpack_public_path__ + "static/gothic-a1-v8-latin-500-dc6d276056b6fbc1e1750edc43686ea1.woff2";